import { Navbar, Container, Nav, NavDropdown } from "react-bootstrap";

function Impressum() {
  return (
    <Container>
      <br />
      <h2>
        <strong>Impressum</strong>
      </h2>
      <br />
      <h3>Angaben gemäß § 5 TMG</h3>
      <p>
        Sabine Adams (Dipl. Ing (FH))
        <br /> Einzelunternehmer CAD-Schulungen <br /> Chorherrenweg 23
        <br />
        59494 Soest
      </p>
      <br />
      <h3>Kontakt:</h3>
      <p>
        Telefon: +49 151 1766 2979
        <br />
        E-Mail: s.adams@cad-adams.de
        <br />
        Website: www.cad-adams.de
      </p>
      <p> </p>
      <br />

      <h4>Steuer-ID</h4>
      <p>
        Steuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:
        <br />
        343/5000/7214
      </p>
      <br />
      <h4>Bei redaktionellen Inhalten:</h4>
      <p>
        Verantwortlich nach § 55 Abs.2 RStV
        <br />
        Sabine Adams
        <br />
        Chorherrenweg 23
        <br />
        59494 Soest
      </p>
      <br />
      <h3>Urheberrecht</h3>
      <p>
        Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen
        Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung,
        Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der
        Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des
        jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite
        sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
        <br /> <br />
        Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden,
        werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte
        Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine
        Urheberrechtsverletzung aufmerksam werden, bitten wir um einen
        entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden
        wir derartige Inhalte umgehend entfernen.{" "}
      </p>
      <br />
      <br />
    </Container>
  );
}

export default Impressum;
